import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useClock } from "react-use-clock";

import { dropUserConfig } from "../../redux/slices/auth.feature";
import LanguageSelector from "./LanguageSelector";
import { IRootState } from "../../types/redux/IRootStore";
import { ModalType } from "../common/Modals/types/modalType";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { userHasPermissionAnyLine } from "../../aplUtils/permissions";
import { UserPermission } from "../../types/userPermission";
import { onClearPalletSearch } from "../../redux/slices/palletCache.feature";
import { clearPalletCache } from "../../redux/slices/palletCache.feature";
import { showModalWithoutPallets } from "../../redux/slices/modalPallets2.feature";
import { clearWorkorderManagement } from "../../redux/slices/workorderItems.feature";
import { AplParameter } from "../../types/aplParameter";
import { parseBool } from "../../aplUtils/extensions";

let NavBar = () => {
    const aplSettings = AplSettingsSelector();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const logOut = () => {
        dispatch(dropUserConfig(authStateRedux.refreshToken) as any);
    };

    const clock = useClock();
    let authStateRedux = useSelector((state: IRootState) => state.auth);

    const permWorkorderManagement =
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.JWOUser) ||
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.JWOAdmin) ||
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.WOMadmin) ||
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.WOMLect);

    const permConsumption =
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.ConsumptionOffLine) ||
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.ConsumptionOnLine);

    const permLabelling =
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.OnlineLabellingFull) ||
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.OfflineLabelling) ||
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.OnlineLabellingLimited);

    const permPalStat = userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.PalletWhsManagement);
    const permAdmin =
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.Admin) ||
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.GlobalPermsAdmin) ||
        userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.SuperAdmin);
    const merck = userHasPermissionAnyLine(aplSettings.permsSets, UserPermission.MerckPrint) && parseBool(aplSettings.getParam(AplParameter.Merck));

    const setPalstatDefaults = () => {
        // console.log("palstat search setting date");
        dispatch(onClearPalletSearch());
        dispatch(clearPalletCache());
    };

    const setWorkorderManagementDefaults = () => {
        dispatch(clearWorkorderManagement());
    };

    return (
        <React.Fragment>
            <nav id="navbarRoot" className="navbar navbar-expand navbar-expand-sm navbar-light float-right">
                <div className="container-fluid padding-right-0">
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                        {/* <!-- merck print --> */}
                        {merck ? (
                                        <li id="navbarMerck">
                                            <span>
                                                <Link
                                                    id="navbarMerckLink"
                                                    className="nav-link active"
                                                    to={"/merck"}
                                                >
                                                    Merck
                                                </Link>
                                            </span>
                                        </li>
                                    ) : (
                                        ""
                                    )}

                            {/* <!-- workorder management --> */}
                            {permWorkorderManagement ? (
                                <li className="nav-item" id="navbarWorkorderManagement">
                                    <Link to={"/workordermanagement"} className="nav-link active" onClick={setWorkorderManagementDefaults}>
                                        {t("main.womTitle")}
                                    </Link>
                                </li>
                            ) : null}
                            {/* <!-- consumption --> */}
                            {permConsumption ? (
                                <li className="nav-item" id="navbarConsumption">
                                    <Link to={"/consumption"} className="nav-link active" id="navbarConsumptionLink">
                                        {t("main.rxg_Consumption")}
                                    </Link>
                                </li>
                            ) : null}{" "}
                            {/* <!-- labels --> */}
                            {permLabelling ? (
                                <li className="nav-item" id="navbarLabels">
                                    <Link to={"/labels"} className="nav-link active" id="navbarLabelsLink">
                                        {t("main.labels")}
                                    </Link>
                                </li>
                            ) : null}
                            {/* <!-- labels --> */}
                            {permPalStat ? (
                                <li className="nav-item" id="navbarPalletStatus">
                                    <Link
                                        className="nav-link active"
                                        to={"/palstat"}
                                        id="navbarPalletStatusLink"
                                        onClick={setPalstatDefaults}
                                    >
                                        {t("main.palletStatus")}
                                    </Link>
                                </li>
                            ) : null}
                            {/* <!-- admin dropdown menu --> */}
                            <li className="nav-item active dropdown dropdown-menu-right">
                                <Link
                                    className="nav-link dropdown-toggle"
                                    to={""}
                                    id="navbarAdminDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {authStateRedux.userName}
                                </Link>
                                <ul
                                    className="dropdown-menu dropdown-menu-end dropdown-menu-lg-start min-width-0"
                                    aria-labelledby="navbarDropdown"
                                >
                                    {/* <!-- print history modal --> */}
                                    <li id="navbarAdminPrintHistoryModal">
                                        <span>
                                            <Link
                                                id="navbarAdminPrintHistoryModalLink"
                                                className="dropdown-item"
                                                onClick={() => {
                                                    dispatch(
                                                        showModalWithoutPallets({ modal: ModalType.PrintHistory, caller: ModalType.None })
                                                    );
                                                }}
                                                to={""}
                                            >
                                                {t("main.litPrintHistory")} &nbsp;
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-arrow-up-right-square"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm5.854 8.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"
                                                    />
                                                </svg>
                                            </Link>
                                        </span>
                                    </li>

                                    

                                    {/* <!-- crew --> */}
                                    {/* <li id="navbarAdminCrew">
                                        <Link id="navbarAdminCrewLink" className="dropdown-item" to={"/crew"}>
                                            Crew
                                        </Link>
                                    </li> */}

                                    {permAdmin ? (
                                        <li id="navbarAdminDividerAdmin">
                                            <hr className="dropdown-divider" />
                                        </li>
                                    ) : (
                                        ""
                                    )}

                                    {/* <!-- admin permissions--> */}
                                    {permAdmin ? (
                                        <React.Fragment>
                                            <li id="navbarAdminUsersAdmin">
                                                <Link id="navbarAdminUsersAdminLink" className="dropdown-item" to={"/admin/usersadmin"}>
                                                    Users Permissions
                                                </Link>
                                            </li>
                                            <li id="navbarAdminPritnersAssignment">
                                                <Link
                                                    id="navbarAdminPritnersAssignmentLink"
                                                    className="dropdown-item"
                                                    to={"/admin/printerline"}
                                                >
                                                    Printers Assignment
                                                </Link>
                                            </li>
                                            {/* <!-- admin sqldeploy--> */}
                                            <li id="navbarAdminSqlDeploy">
                                                <Link id="navbarAdminSqlDeployLink" className="dropdown-item" to={"/admin/sqldeploy"}>
                                                    SQL Deploy
                                                </Link>
                                            </li>
                                        </React.Fragment>
                                    ) : (
                                        ""
                                    )}
                                    {permAdmin ? (
                                        <React.Fragment>
                                            <li id="navbarAdminRoleEditor">
                                                <Link id="navbarAdminRoleEditorLink" className="dropdown-item" to={"/admin/rolefeature"}>
                                                    Roles Admin
                                                </Link>
                                            </li>
                                        </React.Fragment>
                                    ) : (
                                        ""
                                    )}
                                    <li id="navbarAdminDividerSuperAdmin">
                                        <hr className="dropdown-divider" />
                                    </li>
                                    {/* <!-- change password --> */}
                                    <li id="navbarAdminChangePassword">
                                        <Link id="navbarAdminChangePasswordLink" className="dropdown-item" to={"/user/password"}>
                                            Change Password
                                        </Link>
                                    </li>
                                    {/* <!-- log out --> */}
                                    <li id="navbarAdminLogOut">
                                        <Link
                                            id="navbarAdminLogOutLink"
                                            className="dropdown-item"
                                            // href="/Account/Logout.aspx"
                                            onClick={logOut}
                                            to="/"
                                        >
                                            {t("main.logout")}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <LanguageSelector />
                            <li>&nbsp;</li>
                            <li>&nbsp;</li>
                            <li className="nav-link active bold">
                                <span>&nbsp;</span>
                                <span id="txtPlant" className="clock-plant">
                                    {`${clock.hours.toString().padStart(2, "0")}:${clock.minutes.toString().padStart(2, "0")}`}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </React.Fragment>
    );
};
export default NavBar;
